import { render, staticRenderFns } from "./OperationRemarks.vue?vue&type=template&id=a31e0b52&"
import script from "./OperationRemarks.vue?vue&type=script&lang=js&"
export * from "./OperationRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports